import { useDispatch } from 'react-redux';
import CarouselButtons from '../presentational/CarouselButtons';
import { defrostCard, freezeCard } from 'lib/actions';
import { useRestrictedAction } from 'hooks';
import { CardStatus } from 'lib/type';
import useCountdownTimer from 'lib/hooks/useCountdownTimer';
import { useEffect } from 'react';

const CarouselButtonsContainer = ({
    onPrevClick,
    onNextClick,
    onViewPinClick,
    start,
    end,
    card,
    isDormant,
}) => {
    const dispatch = useDispatch();
    const status = !!card && !!card.status && card.status;
    const isFrozen = status === CardStatus.TERMINATED;

    const storedEndTime = sessionStorage.getItem('countdownEndTime');

    const initialValue = storedEndTime
        ? Math.max(
              0,
              Math.floor(
                  (Number.parseInt(storedEndTime, 10) - Date.now()) / 1000,
              ),
          )
        : 30;

    const {
        remainingSeconds,
        startCountdown,
        isCountdownActive,
    } = useCountdownTimer(initialValue);

    const isDisabledCard =
        isDormant ||
        [
            CardStatus.LOST,
            CardStatus.STOLEN,
            CardStatus.DAMAGED,
            CardStatus.ISSUED,
            CardStatus.RISK,
            'N',
        ].includes(status);

    const { handleRestrictedAction } = useRestrictedAction();

    const toggleFreeze = async () => {
        if (isFrozen) await dispatch(defrostCard(card.cardSerial));
        else await dispatch(freezeCard(card.cardSerial));
        const endTime = Date.now() + 30 * 1000;
        sessionStorage.setItem('countdownEndTime', endTime.toString());
        startCountdown();
    };

    useEffect(() => {
        if (storedEndTime) {
            const secondsLeft = Math.max(
                0,
                Math.floor(
                    (Number.parseInt(storedEndTime, 10) - Date.now()) / 1000,
                ),
            );
            if (secondsLeft > 0) {
                startCountdown();
            }
        }
    }, [storedEndTime, startCountdown]);

    return (
        <CarouselButtons
            onNextClick={onNextClick}
            onPrevClick={onPrevClick}
            onViewPinClick={onViewPinClick}
            toggleFreeze={() => handleRestrictedAction(toggleFreeze)}
            start={start}
            end={end}
            isFrozen={isFrozen}
            isDisabledCard={isDisabledCard}
            remainingSeconds={remainingSeconds}
            isCountdownActive={isCountdownActive}
        />
    );
};

export default CarouselButtonsContainer;
